module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Media/CD-f7ab6b019eeb6cf3ac659c9604cdcfe7.svg";